import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { API } from '../../config';
import axios from 'axios';

const ProfileRedirect = () => {
  const { login } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Check if redirected from auth with session_id in hash
        const hash = window.location.hash;
        console.log('Profile redirect hash:', hash);
        
        if (hash.includes('session_id=')) {
          const sessionId = hash.split('session_id=')[1];
          console.log('Found session ID:', sessionId);
          
          // Clear the hash
          window.location.hash = '';
          
          // Authenticate with the session ID
          await login(sessionId);
          
          // Redirect to main app
          window.location.pathname = '/';
        } else {
          // Add a small delay to prevent flash of error message
          setTimeout(() => {
            console.log('No session_id found in hash');
            setError('No session ID found');
            // Redirect back to login after showing error
            setTimeout(() => {
              window.location.pathname = '/';
            }, 1500);
          }, 500); // 500ms delay before showing error
        }
      } catch (error) {
        console.error('Authentication failed:', error);
        setError('Authentication failed');
        // Redirect back to login after a delay
        setTimeout(() => {
          window.location.pathname = '/';
        }, 2000);
      } finally {
        // Set loading to false after a minimum time to prevent flash
        setTimeout(() => {
          setLoading(false);
        }, 600);
      }
    };

    handleAuthCallback();
  }, [login]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Authenticating...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 18.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <p className="text-red-600 mb-4">{error}</p>
          <p className="text-gray-600">Redirecting back to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing authentication...</p>
      </div>
    </div>
  );
};


export default ProfileRedirect;
